var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" アクセスが拒否されました、十分な権限がありません ")])
}
var staticRenderFns = []

export { render, staticRenderFns }